export default function (state, getters, rootState, rootGetters) {
    return (state.page - 1) * getters.setting.col;
}